export default "__VITE_ASSET__CF9dPiy5__"